
export default class Lesson {
  public id: number = 0
  public name: string = ""
  public sort: number = 0
  public categoryId: number = 0
}